/* tslint:disable */

declare var Object: any;
export interface TtadattcorrectionInterface {
  "attrequestcode": string;
  "companyId": number;
  "requestby": string;
  "requestfor": string;
  "requestdate": Date;
  "correctionBegindate": Date;
  "correctionEnddate": Date;
  "approvalStatus": number;
  "createdDate": Date;
  "createdBy": string;
  "modifiedDate": Date;
  "modifiedBy": string;
  "uploadFilename"?: string;
  tcltrequests?: any;
  request_for?: any;
  ttadattcorrectiondetails?: any[];
}

export class Ttadattcorrection implements TtadattcorrectionInterface {
  "attrequestcode": string;
  "companyId": number;
  "requestby": string;
  "requestfor": string;
  "requestdate": Date;
  "correctionBegindate": Date;
  "correctionEnddate": Date;
  "approvalStatus": number;
  "createdDate": Date;
  "createdBy": string;
  "modifiedDate": Date;
  "modifiedBy": string;
  "uploadFilename": string;
  tcltrequests: any;
  request_for: any;
  ttadattcorrectiondetails: any[];
  constructor(data?: TtadattcorrectionInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Ttadattcorrection`.
   */
  public static getModelName() {
    return "Ttadattcorrection";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Ttadattcorrection for dynamic purposes.
  **/
  public static factory(data: TtadattcorrectionInterface): Ttadattcorrection{
    return new Ttadattcorrection(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Ttadattcorrection',
      plural: 'Ttadattcorrections',
      path: 'Ttadattcorrections',
      properties: {
        "attrequestcode": {
          name: 'attrequestcode',
          type: 'string'
        },
        "companyId": {
          name: 'companyId',
          type: 'number'
        },
        "requestby": {
          name: 'requestby',
          type: 'string'
        },
        "requestfor": {
          name: 'requestfor',
          type: 'string'
        },
        "requestdate": {
          name: 'requestdate',
          type: 'Date'
        },
        "correctionBegindate": {
          name: 'correctionBegindate',
          type: 'Date'
        },
        "correctionEnddate": {
          name: 'correctionEnddate',
          type: 'Date'
        },
        "approvalStatus": {
          name: 'approvalStatus',
          type: 'number'
        },
        "createdDate": {
          name: 'createdDate',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'string'
        },
        "modifiedDate": {
          name: 'modifiedDate',
          type: 'Date'
        },
        "modifiedBy": {
          name: 'modifiedBy',
          type: 'string'
        },
        "uploadFilename": {
          name: 'uploadFilename',
          type: 'string'
        },
      },
      relations: {
        tcltrequests: {
          name: 'tcltrequests',
          type: 'any',
          model: ''
        },
        request_for: {
          name: 'request_for',
          type: 'any',
          model: ''
        },
        ttadattcorrectiondetails: {
          name: 'ttadattcorrectiondetails',
          type: 'any[]',
          model: ''
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Ttadattcorrection.ts